module.exports = __webpack_public_path__ + "static/media/w_12.d708d549.png";